import { render, staticRenderFns } from "./_4.vue?vue&type=template&id=2aeda84e&"
import script from "./_4.vue?vue&type=script&lang=js&"
export * from "./_4.vue?vue&type=script&lang=js&"
import style0 from "./_4.vue?vue&type=style&index=0&id=2aeda84e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports